@if (!isClientConsent) {
<app-authentication
	[userNamePlaceHolder]="isCardLogin ? 'AMIS CARD NUMBER' : 'User Name'"
	[passwordPlaceHolder]="isCardLogin ? 'PIN' : 'Passsword'"
	[userNameMaxLength]="isCardLogin ? 14 : null"
	[passwordMaxLength]="isCardLogin ? 6 : null"
	[onValidation]="validateLogin()"
	(onLoginCompleted)="afterLogin()">
</app-authentication>
}
@else {
<div class="ui middle aligned center aligned grid"
	style="height: 100%;">
	<div class="column"
		[ngStyle]="{'width': redirectingToClient ? '400px' : '650px'}">
		<div class="ui padded segment"
			app-loading
			[enabled]="loading || redirectingToClient"
			[text]="(redirectingToClient ? 'Please hold on while you are being redirected to ' + verifiedClient.name : 'Loading')"
			style="text-align: left;">

			<h5 class="ui header"
				style="margin-bottom: 20px;">
				<i class="user shield icon"></i>
				<div class="content">
					Client Authorization
					<div class="sub header">Consent to Data Access</div>
				</div>
			</h5>

			<div style="font-style: italic;">
				@if (isTotalClient) {
				By proceeding, you are authorizing <strong>CircleK</strong> to perform the following actions in <strong>NSTEP</strong> on your behalf:

				<ul>
					<li><span class="ui green text" style="font-weight: bold;">Read data</span>: Access your fuel rations in <strong>NSTEP</strong>, as required.</li>
					<li><span class="ui red text" style="font-weight: bold;">Write data</span>: Reduce/add fuel entitlements in <strong>NSTEP</strong> based on your purchases/returns in <strong>CircleK</strong>.</li>
				</ul>

				This access is required to allow you to purchase fuel from <strong>CircleK</strong>.
				<br /><br />

				If you do not agree, <strong>CircleK</strong> will delete your account, and you will not be able to purchase fuel for your <br/><strong>Total Refillable Card</strong>.
				}
				@else {
				By proceeding, you are authorizing <strong>{{verifiedClient.name}}</strong> to perform the following actions in <strong>NSTEP</strong> on your behalf:

				<ul>
					<li><span class="ui green text" style="font-weight: bold;">Read data</span>: Access your data stored in NSTEP as required.</li>
					<li><span class="ui red text" style="font-weight: bold;">Write data</span>: Modify or add data to NSTEP based on your actions.</li>
				</ul>

				This access is required to enhance your experience with <strong>{{verifiedClient.name}}</strong> by synchronizing your <strong>NSTEP</strong> data seamlessly.
				}
			</div>

			<br />

			<div style="text-align: center;">

				<div class="ui small buttons">
					<button class="ui red icon button"
						(click)="consentClient(false)"
						*ngIf="!isTotalClient">
						<i class="cancel icon"></i>
						&nbsp;&nbsp;DENY&nbsp;&nbsp;&nbsp;&nbsp;
					</button>

					<div class="or"
						*ngIf="!isTotalClient">
					</div>

					<button class="ui green icon button"
						(click)="consentClient(true)">
						&nbsp;&nbsp;&nbsp;&nbsp;{{isTotalClient ? 'AGREE' : 'ALLOW'}}&nbsp;&nbsp;
						<i class="check icon"></i>
					</button>
				</div>
			</div>
		</div>
	</div>
</div>
}